<template>
<div class="login-wrap">
    <div class="login-top">
        <div class="logo">ecer</div>
    </div>
    <div class="bg-wrap">
        <div class="ecer-bg"></div>
        <div class="cicle-bg"></div>
        <div class="login-content-wrap">
            <div class="border">
                <div class="login-form-warp">
                    <form>
                    <div class="content-box">
                        <h1>{{$t('login.title1')}}</h1>
                        <h2>{{$t('login.title2')}}</h2>
                        <div class="login-form-group" v-on:click.stop="inputFocus(1)" >
                            <label v-bind:class="{ 'text-blue': userNameStatus,'text-tip':!userNameStatus,'text-error':errorName }">{{$t('login.account')}}</label>
                            <input type="email" name="userName" maxlength="100" v-model.trim="userName" autocomplete="off" v-bind:class="{'border-error':errorName,'border-default':!errorName}" @blur="inputBlur(1,userName)">
                            <!-- <div class="text-right text-error f-12" v-show="errorName">wrong msg</div> -->
                        </div>
                        <div class="login-form-group" v-on:click.stop="inputFocus(2)" @keyup.enter="login">
                            <label v-bind:class="{ block : userPwdStatus || errorPwd,'text-blue':userPwdStatus,'text-tip': !userPwdStatus,'text-error':errorPwd}">{{$t('login.password')}}</label>
                            <input type="password" name="password" maxlength="50" v-model.trim="userPwd" placeholder="Password" v-bind:class="{'border-default':!errorPwd}" @blur="inputBlur(2,userPwd)">
                            <div class="text-right text-error f-12" v-show="errorTip || !canSubmit || errorName || errorPwd">{{errorMsg}}</div>
                        </div>
                        <div class="checkbox">
                            <el-checkbox v-model="remmerber" true-label="1" false-label="0">{{$t('login.remPassword')}}</el-checkbox>
                        </div>
                        <el-button type="primary" class="sign-btn" v-on:click="login" :loading="loading">{{$t('login.login')}}</el-button>
                        <div class="forget">
                            <a style="cursor:pointer;" :href="resetPswdUrl" target="_blank" >{{$t('login.forgetPassword')}}</a>
                        </div>
                    </div>
                    </form>
                </div>
                <div class="login-blue-warp">
                    <p>{{$t('login.slog1')}}<br> {{$t('login.slog2')}}</p>
                </div>
            </div>
            <el-row type="flex" justify="space-between" class="login-footer">
                <el-col :span="6"><div class="grid-content">{{$t('login.lang')}}</div></el-col>
                <el-col :span="12"><div class="grid-content text-right"><span class="m-r-60">{{$t('login.term')}}</span>{{$t('login.privacy')}}</div></el-col>
            </el-row>
        </div>
    </div>
    
    <el-dialog
        :title="$t('login.selectUser')"
        :visible.sync="dialogStatus"
        width="40%">
        <div>
            <div>
                <el-radio v-model="userTypeStatus" label="1">{{$t('login.admin')}}</el-radio>
            </div>
            <div class="m-t-15">
                <el-radio v-model="userTypeStatus" label="0">{{$t('login.user')}}</el-radio>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogStatus = false">{{$t('login.cancel')}}</el-button>
            <el-button size="small" type="primary" :loading="typeLoading" @click="linkToStatus(userTypeStatus)">{{$t('login.yes')}}</el-button>
        </span>
    </el-dialog>
</div>
</template>
<style lang="scss" src="./../assets/scss/login.scss"></style>
<script>
import axios from 'axios'
export default {
    data(){
        return {
            userName:'',
            userPwd:'',
            userTypeStatus:null,
            typeLoading:false,
            userNameStatus:false, //前端状态字段
            userPwdStatus:false,
            errorName:false,
            errorPwd:false,
            errorTip:false,
            errorMsg:this.$t('login.error'),
            
            remmerber:0,
            loading:false,
            dialogStatus:false,  //todo 是否显示弹窗
            canSubmit:true,
            sessionData:null,
            resetPswdUrl:null,
        }
    },
    components:{},
    mounted() {
        if(!!sessionStorage.getItem('sid')){
            this.$router.replace('/');
        }else{
            const userlocal = JSON.parse(sessionStorage.getItem('userInfo')) || null;
            if(!!userlocal){
                this.userName = userlocal.userName || '';
                if(userlocal.remmerber == 1){
                    this.userPwd =  userlocal.password;
                    this.remmerber = userlocal.remmerber;
                }
            }
        }
        this.resetPswdUrl = axios.defaults.homeURL + '/#/resetpassword';
    },
    methods:{
        inputFocus(type){
            if(type==1){
                this.userNameStatus = true;
                this.errorName = false;
                this.errorTip = false;
                this.canSubmit = true;
            }
            if(type==2){
                this.userPwdStatus = true;
                this.errorPwd = false;
                this.errorTip = false;
                this.canSubmit = true;
            }
        },
        inputBlur(type,value){
            if(type==1){
                this.userNameStatus = false;
                if(value == null || value == ""){
                    this.errorName = true;
                    this.canSubmit = false;
                    this.errorTip = true;
                }else{
                    /*
                    var apos=value.indexOf("@"),
                        dotpos=value.lastIndexOf(".");
                    if (apos<1||dotpos-apos<2){
                        this.errorName = true;
                        this.canSubmit = false;
                        this.errorTip = true;
                        this.errorMsg = "Not a valid e-mail address."
                    }*/
                }
            }
            if(type==2){
                this.userPwdStatus = false;
                if(value == null || value == ""){
                    this.errorPwd = true;
                    this.canSubmit = false;
                }
                // else{  //191028去掉登陆的密码长度校验
                //     if(value && value.length>0){
                //         if(value.length<8){
                //             this.errorPwd = true;
                //             this.canSubmit = false;
                //             this.errorTip = true;
                //             this.errorMsg = "Password length not less than 8."
                //         }
                //     }
                // }
            }
        },
        login(){
            let _self = this;
            _self.inputBlur(1,_self.userName);
            _self.inputBlur(2,_self.userPwd);
            if(!!_self.canSubmit){
                _self.loading = true;
                axios.post("?_task=login&_action=login", {
                _user:_self.userName,
                _pass:_self.userPwd,
                _lang:localStorage.getItem('language') == null?(_self.$i18n.locale == 'en_us'?'en_US':'zh_CN'):(localStorage.getItem('language') == 'en_us'?'en_US':'zh_CN'),
                _channel:'0010'
                })
                .then(function (response) {
                    let res = response.data;
                    if(res.code == 0){
                        _self.errorTip = false;
                        _self.sessionData = {
                            // userName:'liuhong@phrmg.org',
                            // password:'Qwer1234',//_channel:'0010',
                            userName:_self.userName,
//                          password:_self.userPwd,
                            _lang:localStorage.getItem('language') == null?(_self.$i18n.locale == 'en_us'?'en_US':'zh_CN'):(localStorage.getItem('language') == 'en_us'?'en_US':'zh_CN'),
                            _sid:res.data.sess_id,
                            im_id:res.data.im_id,
                            im_nick:res.data.im_nick,
                            role_admin:res.data.role_admin,
                            role_mail:res.data.role_mail,
                            portrait:res.data.portrait,
                            remmerber:_self.remmerber,
                            theme_bgimage:res.data.theme_bgimage,
                        }
                        if(_self.$db){
                            _self.$db.close();
                            _self.$db.version(1).stores({
                                emails: "&message_id,timestamp,content",
                            });
                            _self.$db.open();
                            //删除500封以上最老的邮件
				            _self.$db.emails.orderBy('timestamp').reverse().offset(500).delete();
                        }
                        let _json = {
                            _sid: res.data.sess_id,
                        }
                        axios.get('?_task=mail&_action=user', {
                            params: _json})
                        .then(function(res) {
                            if(res.data.code == 0) {
                                _self.loading = false;
                                sessionStorage.setItem('quota_info',JSON.stringify(res.data.data.quota_info)); //空间使用
                                sessionStorage.setItem('user_dataInfo',JSON.stringify(res.data.data.user_info)); //头部用户信息
                                sessionStorage.setItem('circleUrl',res.data.data.user_info.portrait); //图像
                                sessionStorage.setItem('generalTime',JSON.stringify(res.data.data.general)); //自动操作时间
                                sessionStorage.setItem('baseTime',res.data.now_time);
                                sessionStorage.setItem('notify_info',JSON.stringify(res.data.data.notify_info));
                                _self.$router.replace('/');
                            }
                        }).catch(function(error) {
                        });
                        
                        if(res.data.role_admin == 1 && res.data.role_mail == 0){
                            const _url = axios.defaults.adminURL + '?' + window.btoa('username='+_self.userName+'&password='+_self.userPwd);
                            window.location.href = _url;
                            
                        }
                        if(res.data.role_admin == 1 && res.data.role_mail == 1){
                            _self.userTypeStatus = '1',
                            _self.dialogStatus = true;
                        }
                        if(res.data.role_admin == 0 && res.data.role_mail == 1){
                            sessionStorage.clear();
                            sessionStorage.setItem('sid',res.data.sess_id);
                            sessionStorage.setItem('themeImage',res.data.theme_bgimage);
                            sessionStorage.setItem('userInfo',JSON.stringify(_self.sessionData));
                        }
                    }else{
                        _self.errorTip = true;
                        _self.errorMsg = res.message;
                        _self.loading=false;
                    }
                })
                .catch(function (error) {
                    _self.loading = false;
                    _self.errorName = true;
                    _self.errorPwd = true;
                    _self.errorTip = true;
                    _self.errorMsg = error;
                    //toast component
                });
            }
        },
        linkToStatus(type){
            const _self = this;
            _self.typeLoading = true;
            if(type==1){
                const _url = axios.defaults.adminURL + '?' + window.btoa('username='+_self.userName+'&password='+_self.userPwd);
                window.location.href = _url;
                _self.dialogStatus = false;
                _self.typeLoading = false;

            }else{
//              sessionStorage.clear();
                sessionStorage.setItem('sid',_self.sessionData._sid);
                sessionStorage.setItem('userInfo',JSON.stringify(_self.sessionData));
                sessionStorage.setItem('themeImage',_self.sessionData.theme_bgimage);
                _self.$router.replace('/');
                
                _self.dialogStatus = false;
                _self.typeLoading = false;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue